import React from 'react';
import { useTranslation } from 'react-i18next';
import { emailAddresses, routes } from '../../constants';
import EmptySearchStateImage from '../Search/SearchResults/EmptySearchResultsNewUI/EmptySearchStateImage';
import { Box, Typography, Link, Button } from '@mui/material';
import useRouter from '../../utils/useRouter';
import { spaces } from '../../assets/styles/themes/tokens';

const ChangeEmailError = () => {
  const { t } = useTranslation();
  const { router } = useRouter();

  const SubTitle = () => (
    <Typography variant='body2' sx={{ textAlign: 'center', display: 'block' }}>
      {t('Please') + ' '}
      <Link href={`/${routes.personalDetails.root}/profil`}>
        {t('Try again to change your email address')}
      </Link>
      {` ${t('Or contact')} `}
      <Link href={`mailto:${emailAddresses.support}`} underline='none'>
        {emailAddresses.support}
      </Link>.
    </Typography>
  );

  return (
    <Box 
      data-testid='change-email-error'
      sx={{
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center' ,
        gap: spaces.lg,
      }}
    > 
      <EmptySearchStateImage
        title={t('Ups, something went wrong')}
        subtitle={<SubTitle />}
        iconName='errorFlatline'
        subtitleSx={{ textAlign: 'center' }}
        containerSx={{ paddingBottom: 0, width: '100%' }}
        iconContainerSx={{ width: 'inherit' }}
      />
      <Button 
        variant='outlined' 
        color='primary' 
        size='large' 
        onClick={() => router.push(`/${routes.dashboard.root}`)}
      >
        {t('Back to meinUnterricht')}
      </Button>
    </Box>
 
  );
};

export default ChangeEmailError;
